import { TIME_SIGNATURES } from '../config/timeSignatures';
import type { DrumInstrument, DrumGridData, TimeSignature, NoteDivision } from '../types';

function getBarDivisions(timeSignature: TimeSignature, stepsPerBar: number): number {
  const { beats } = TIME_SIGNATURES[timeSignature];
  const stepsPerBeat = stepsPerBar / beats;
  return stepsPerBeat;
}

interface GenerateAsciiTxtParams {
  grid: DrumGridData;
  instruments: DrumInstrument[];
  stepsPerBar: number;
  bpm: number;
  drumKitId?: string;
  timeSignature: TimeSignature;
  noteDivision: NoteDivision;
}

export const generateAsciiTxt = ({
  grid,
  instruments,
  stepsPerBar,
  bpm,
  drumKitId,
  timeSignature,
  noteDivision
}: GenerateAsciiTxtParams): string => {
  // 生成 ASCII 格式的鼓譜
  const asciiLines = instruments
    .map(({ id }) => {
      if (!grid[id]) return `${id}: ${''.padEnd(stepsPerBar, '-')}`;
      const line = grid[id].slice(0, stepsPerBar).map((v, i) => {
        const mark = v || '-';
        return (i % getBarDivisions(timeSignature, stepsPerBar) === 0 && i !== 0 ? '|' : '') + mark;
      });
      return `${id}: ${line.join('')}`;
    })
    .join('\n');

  // 添加元數據標頭
  const header = [
    `# ASCII Drum Pattern Export`,
    `# Generated: ${new Date().toISOString()}`,
    `# Time Signature: ${timeSignature}`,
    `# Note Division: ${noteDivision}`,
    `# Tempo: ${bpm} BPM`,
    `# Steps per Bar: ${stepsPerBar}`,
    `# Drum Kit: ${drumKitId || 'Custom'}`,
    `# `,
    `# Legend:`,
    `# x = Normal hit`,
    `# X = Accent hit`,
    `# g = Ghost note`,
    `# f = Flam`,
    `# - = Rest`,
    `# | = Beat division`,
    ``,
  ].join('\n');

  return header + asciiLines;
}; 